import React, {useEffect, useRef} from "react";
import paysafecard from "../assets/paysafecard.png";

interface MethodInfoProps {
  type?: string
}

export default function MethodInfo ({type}: MethodInfoProps) {
  if (type === 'paysafecard') {
    return <div className="method-info">
      <img src={paysafecard} />
      Paysafecard
    </div>
  }

  return null;
}